<template>
  <c-input
    as="multiselect"
    class="multiselect-multiple"
    multiple
    v-model="selectedTags"
    placeholder="Select"
    :close-on-select="false"
    :preselect-first="false"
    :show-labels="false"
    :options="mediaOwnerTags"
    label="name"
    track-by="id"
  />
</template>

<script>
import { get, call } from 'vuex-pathify'

export default {
  props: {
    value: Array
  },

  data () {
    return {
      tagOptions: []
    }
  },

  computed: {
    ...get('lists/mediaOwnerTags', ['mediaOwnerTags']),

    selectedTags: {
      get () {
        const ids = this.value.map(({ id }) => id)

        return this.mediaOwnerTags.filter(({ id }) => {
          return ids.includes(id)
        })
      },

      set (options) {
        this.$emit('input', options)
      }
    }
  },

  methods: {
    getMediaOwnerTags: call('lists/mediaOwnerTags/getMediaOwnerTags')
  },

  async created () {
    this.getMediaOwnerTags()
  }
}
</script>
